import React, { Component } from 'react';
import { useState } from 'react';
import RootRouter from './router/RootRouter'
import { BrowserRouter ,HashRouter} from "react-router-dom";
//
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux'


const App=(props)=>{
  // console.log(props)

  return (
    <HashRouter >
      <RootRouter/>
    </HashRouter>
  );
}

const mapStateToProps =(state)=> {
  
  const {userInfo}=state;
  return {
    userInfo
  }
}


export default connect(mapStateToProps)(App);
// export default App;